import { Link } from "@tanstack/react-router";
import { SetupCopyBlock } from "@/components/setup/SetupCopyBlock";

const EXAMPLE_PROMPTS = [
	"Show me which social accounts are connected in AgentReacher and what is already scheduled.",
	"Help me create my first post. Ask me for the topic, write one LinkedIn draft, and wait for my approval before scheduling it.",
	"Create a simple posting plan for next week with three LinkedIn posts, then prepare the drafts for my review.",
];

export function SetupExamplePrompts({
	agentName = "AgentReacher",
}: {
	agentName?: string;
}) {
	return (
		<section className="rounded-md bg-white px-6 py-12 dark:bg-black sm:px-10 sm:py-14">
			<h3 className="text-base font-semibold text-foreground">
				Try these prompts
			</h3>
			<p className="mt-1 text-sm leading-6 text-muted-foreground">
				Copy any of these and paste into a new chat to put {agentName} to work.
			</p>
			<div className="mt-4 flex flex-col gap-2">
				{EXAMPLE_PROMPTS.map((prompt) => (
					<SetupCopyBlock key={prompt} text={prompt} multiline />
				))}
			</div>
			<Link
				to="/docs/mcp-tools"
				className="mt-5 inline-flex text-sm font-medium text-primary transition-colors hover:text-primary/80"
			>
				View all Tools
			</Link>
		</section>
	);
}
